module.exports = __webpack_public_path__ + "static/media/Crowdfunding.d4926452.svg";